import { render, staticRenderFns } from "./mrbdetailview.vue?vue&type=template&id=328ee2bd&scoped=true&"
import script from "./mrbdetailview.vue?vue&type=script&lang=js&"
export * from "./mrbdetailview.vue?vue&type=script&lang=js&"
import style0 from "./mrbdetailview.vue?vue&type=style&index=0&id=328ee2bd&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328ee2bd",
  null
  
)

export default component.exports